<template>
    <div class="work_order" @click="problemShow = false">
        <Top></Top>
        <div class="container">
            <h1>{{ $t('m.my.workOrder.title') }}</h1>
            <div class="form">
                <form class="request-form">
                    <div class="form-field string  required  request_custom_fields_360004484253">
                        <label>{{ $t('m.my.workOrder.label[1]') }}</label>
                        <a class="nesty-input" v-if="request.wid">{{ submit.classify }}</a>
                        <a class="nesty-input" @click.stop="problemShow = true" v-else>{{ submit.classify }}</a>
                        <div class="problem_container" v-show="problemShow">
                            <div @click="submit.classify = '-'">-</div>
                            <div v-for="(v,k) in list" :key="k"
                                 @click="changeProblem(v.cate_name,v.en_cate_name,v.wcid)">
                                {{ $i18n.locale == 'zh-CN' ? v.cate_name : v.en_cate_name }}
                            </div>
                        </div>
                    </div>
                    <!--<div class="form-field string  request_custom_fields_360003513913">
                        <label for="request_custom_fields_360003513913">{{ $t('m.my.workOrder.label[3]') }}UID</label>
                        <input type="text" id="request_custom_fields_360003513913" v-model="request.account" disabled>
                    </div>
                    <div class="form-field string request_anonymous_requester_email">
                        <label for="request_anonymous_requester_mobile">{{ $t('m.my.workOrder.label[5]') }}</label>
                        <input type="text" id="request_anonymous_requester_mobile" v-model="request.mobile">
                    </div>
                    <div class="form-field string request_anonymous_requester_email">
                        <label for="request_anonymous_requester_email">{{ $t('m.my.workOrder.label[0]') }}</label>
                        <input type="text" id="request_anonymous_requester_email" v-model="request.email">
                    </div>-->
                    <div class="form-field text  required  request_description">
                        <label for="request_description">{{ $t('m.my.workOrder.label[2]') }}</label>
                        <textarea id="request_description" v-model="request.description"></textarea>
                        <p>{{ $t('m.my.workOrder.text[0]') }}</p>
                    </div>
                    <div class="form-field">
                        <label>{{ $t('m.my.workOrder.label[4]') }}</label>
                        <el-upload
                                class="avatar-uploader"
                                :data="upload"
                                :action="requestConfig.host + '/index/File/upload'"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess"
                                name="image"
                                :before-upload="beforeAvatarUpload">
                            <img :src="v" v-for="(v,k) in image" :key="k"
                                 class="avatar" style="display: inline-block;margin-right: 10px;vertical-align: top">
                            <span class="el-icon-plus avatar-uploader-icon"></span>
                        </el-upload>
                        <p>{{ $t('m.my.workOrder.text[1]') }}</p>
                    </div>
                    <div class="submit" @click="submitWorkOrder()">{{ $t('m.my.workOrder.button') }}</div>
                </form>
            </div>
        </div>
        <Bottom></Bottom>
    </div>
</template>

<script>
    import Top from '@/components/top';
    import Bottom from '@/components/bottom';

    export default {
        name: "workOrder",
        components: {
            Top, Bottom
        },
        data() {
            return {
                upload: {},
                problemShow: false,
                list: [],
                submit: {
                    classify: '-'
                },
                image: [],
                request: {
                    mobile: "",
                    email: "",
                    description: "",
                    wcid: "",
                    account: "",
                    b_imgs: [],
                    wid: 0
                },
                isEnd: false
            }
        },
        created() {
            let account = this.$route.query.mobile ? this.$route.query.mobile : this.$route.query.email;
            let type = this.$route.query.mobile ? 2 : 1;
            let uid = Number(this.$route.query.uid);
            let login = this.$route.query.login;
            if (login) {
                this.doLogin(account, type, uid);
            }
            this.request.wid = this.$route.query.wid ? this.$route.query.wid : 0;
            this.request.wcid = this.$route.query.wcid ? this.$route.query.wcid : '';
            this.upload.token = this.userInfo.key;
            setTimeout(() => {
                this.problemList();
            }, 1000);
        },
        methods: {
            doLogin(account, type, uid) {
                let paramData = this.signRequestLogin({
                  account: account,
                  enum: type,
                  uid: uid,
                  deviceCode: this.deviceCode.code,
                  userAgent: this.deviceCode.userAgent
                });
                paramData.signature = this.signature(paramData);
                this.$axios.post(this.requestConfig.host + "/index/Login/login", paramData).then((res) => {
                    return this.checkResponse(res);
                }).then((res) => {
                    this.aUserInfo(res);
                })
            },
            handleAvatarSuccess(res) {
                let obj = {data: res};
                this.checkResponse(obj).then((s) => {
                    console.log(s.path);
                    this.image = this.image.concat(this.requestConfig.host + s.path);
                    this.request.b_imgs = this.request.b_imgs.concat(s.path);
                });
            },
            beforeAvatarUpload(file) {
                const isJPG = (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png');
                const isLt20M = file.size / 1024 / 1024 < 20;

                if (!isJPG) {
                    this.$message.error(this.$t('m.my.certification.alert[0]'));
                }
                if (!isLt20M) {
                    this.$message.error(this.$t('m.my.certification.alert[1]'));
                }
                return isJPG && isLt20M;
            },
            problemList: function () {
                let paramData = this.signRequest({});
                paramData.signature = this.signature(paramData);
                this.$axios.get(this.requestConfig.host + "/index/Workorder/workCateList", {
                    params: paramData,
                }).then((res) => {
                    return this.checkResponse(res);
                }).then((res) => {
                    this.list = res;
                    for (let i in this.list) {
                        if (this.list[i].wcid == this.request.wcid) {
                            this.submit.classify = this.$i18n.locale == 'zh-CN' ? this.list[i].cate_name : this.list[i].en_cate_name
                        }
                    }
                }).catch((e) => {
                    console.log(e);
                    if (e != "20001")
                        this.$message.error(e);
                })
            },
            changeProblem: function (cate_name, en_cate_name,wcid) {
                this.submit.classify = this.$i18n.locale == 'zh-CN' ? cate_name : en_cate_name;
                this.request.wcid = wcid;
            },
            submitWorkOrder: function () {
                if (this.isEnd) {
                    this.$message.error(this.$t('m.assets.text[46]'));
                    return;
                }
                if(this.request.wcid == '' ||
                    this.request.description == ''){
                    this.$message.error(this.$t('m.my.certification.alert[4]'));
                    return;
                }
                this.isEnd = true;
                this.request.b_imgs = JSON.stringify(this.request.b_imgs);
                let paramData = {
                  description: this.request.description,
                  wcid: this.request.wcid,
                  b_imgs: this.request.b_imgs,
                  wid: this.request.wid
                };
                paramData.signature = this.signature(paramData);
                this.$axios.post(this.requestConfig.host + "/index/Workorder/submitProblem?token=" + this.userInfo.key, paramData).then((res) => {
                    return this.checkResponse(res);
                }).then((res) => {
                    this.$message.success(this.$t('m.my.certification.alert[3]'));
                    setTimeout(() => {
                        this.changeRoute('/myWorkOrder');
                        this.isEnd = false;
                    },1000)
                }).catch((e) => {
                    console.log(e);
                    if (e != "20001")
                        this.$message.error(e);
                })
            }
        }
    }
</script>

<style lang="scss">
    @import "../assets/css/work_order.scss";
     .el-upload {
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 16px;
        color: #8c939d;
        width: 78px;
        height: 78px;
        line-height: 78px;
        text-align: center;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
    }

    .avatar-uploader-icon:hover {
        border-color: #409EFF;
    }

    .avatar {
        width: 78px;
        height: 78px;
        display: block;
    }
</style>
